import angular from 'angular';

var module = angular.module('app.login', []);

export default module;